import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';
import Select from 'react-select';
import { PiFilesBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import DropDownButton from '../../components/DropDownButton';
import Loading from '../../components/Loading';
import Historiques from './Historiques';
import AddPaiement from './AddPaiement';
import Dispense from './Dispense';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import { LuFileSpreadsheet } from 'react-icons/lu';
import Swal from 'sweetalert2';

const Factures = () => {
  const [errors, setErrors] = useState(null);
  const [items, setItems] = useState([]);
  const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [factures, setFactures] = useState([]);
  const [showFactures, setShowFactures] = useState([]);
  const [showHistoriques, setShowHistoriques] = useState(false);
  const [showAddPaiement, setShowAddPaiement] = useState(false);
  const [showDispense, setShowDispense] = useState(false);
  const [selectedFacture, setSelectedFacture] = useState(null);
  const { token, setToken, user } = useStateContext();
  const tableRef = useRef();
  const [type, setType] = useState('');
  const [somme, setSomme] = useState({
    totalRest: 0,
    totalPayee: 0,


  })
  const [req, setReq] = useState({
    'DateDebut': '',
    'DateFin': '',
    'mois': 0,
  });
  const navigate = useNavigate();
  // handle input change event

  const handleInputChange = value => {
    setValue(value);
  };

  // handle selection
  const handleChange = value => {
    setSelectedValue(value);
    setReq({ ...req, mois: value.id })

  }

  useEffect(() => {
    getMois();
  }, []);

  useEffect(() => {
    filtrer();
  }, [type]);

  const filtrer = () => {
    if (type === 'n') {
      setShowFactures(factures.filter(o => (o.total - o.dispense - o.payee) > 0));
    }
    else {
      if (type === 'v') {
        setShowFactures(factures.filter(o => (o.total - o.dispense - o.payee) <= 0));
      } else {
        setShowFactures(factures);
      }
    }
  }

  const getMois = () => {
    axiosClient.get('/mois-scolaires')
      .then((data) => {
        setItems(data.data.mois);
      })
  }
  const closeHistorique = () => {
    setSelectedFacture(null);
    setShowHistoriques(false);
    //getFacture();
  }
  const closeAddPaiement = () => {
    setShowAddPaiement(false);
    setSelectedFacture(null);

    //getFacture();
  }

  const closeDispense = () => {
    setShowDispense(false);
    setSelectedFacture(null);

    //getFacture();
  }
  const getFacture = () => {
    setType('');
    setLoading(true);
    if (selectedValue != null) {
      axiosClient.get('/monthFactures/' + req.mois)
        .then(response => {
          setFactures(response.data.factures);
          setShowFactures(response.data.factures);
          setLoading(false);
          setErrors(null);
        }).catch(err => {
          const response = err.response;
          if (response.status === 401) {
            setToken(null);
          }
          else {
            if (response.status === 422) {
              setErrors(response.data.errors);
              setLoading(false);
              toast.error('Merci de verifier les informations a saisies!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else {
              if (response.status === 403) {
                navigate('/403');
              } else {
                if (response.status === 404) {
                  navigate('/404');
                }
                else {
                  navigate('/500');
                }
              }
            }

          }
        })
    } else {
      axiosClient.get('/getFactures?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin,)
        .then(response => {
          setFactures(response.data.factures);
          setShowFactures(response.data.factures);
          setLoading(false);
          setErrors(null);
        }).catch(err => {
          const response = err.response;
          if (response.status === 401) {
            setToken(null);
          }
          else {
            if (response.status === 422) {
              setErrors(response.data.errors);
              setLoading(false);
              toast.error('Merci de verifier les informations a saisies!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else {
              if (response.status === 403) {
                navigate('/403');
              } else {
                if (response.status === 404) {
                  navigate('/404');
                }
                else {
                  navigate('/500');
                }
              }
            }

          }
        })
    }

  }

  const supprimerFacture = (facture) => {
        setErrors(null);
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/facture/' + facture.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getFacture();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 422) {
                                setErrors(response.data.errors);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

  const generer = () => {
    axiosClient.post('genererFactures', req)
      .then(response => {
        toast.success('Operation effectuee avec succes!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setErrors(null);
      }).catch(err => {
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoading(false);
            toast.error('Merci de verifier les informations a saisies!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })
  }
  return (
    <>
      <Header icon={<LuFileSpreadsheet />} title="Factures" />
      {errors &&
        Object.keys(errors).map(key => (
          <Alert key={key} message={errors[key][0]} />
        ))
      }
      <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
        <Input label="Date debut" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
        <Input label="Date fin" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />
        <Input label="Expression (n ou v)" type="text" value={type} onChange={ev => setType(ev.target.value)} />
        <div className='mt-8 flex gap-2' >
          <Button onClick={() => getFacture()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
          <DownloadTableExcel
            filename="Factures"
            sheet="Factures"
            currentTableRef={tableRef.current}
          >
            <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

          </DownloadTableExcel>
        </div>
      </div>

      <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap '>

        <div className=' mt-12'>


          <div className='flex flex-col mt-2'>
            <label>Mois Scolaire</label>
            <Select className='mt-4 outline-1 ' placeholder="Selectionner un Mois scolaire" cacheOptions defaultOptions value={selectedValue} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={items} onInputChange={handleInputChange} onChange={handleChange} />
          </div>
          <div className="flex gap-2 mt-2">
            {user.role && user.role.name === "caissier" ?
              <Button onClick={() => generer()} color="bg-blue-500" icon={<PiFilesBold />} size="20" text="Generer" textColor="text-white" />
              :
              <></>
            }
          </div>

        </div>
        <div className="mt-12">

        </div>
      </div>
      <div className="flex my-2 gap-3">
        <h1 className='text-red-500 font-bold'>Total Reste: {showFactures.reduce((n, { reste }) => n + parseFloat(reste), 0)} MRU</h1>
        <h1 className='text-green-700 font-bold'>Total Payée: {showFactures.reduce((n, { payee }) => n + parseFloat(payee), 0)} MRU</h1>
      </div>
      <div className='flex mt-3 overflow-auto'>

        <table ref={tableRef} className='table-auto' >
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Elève</th>
              <th>Classe</th>
              <th>Tel</th>
              <th>Date Insc</th>
              <th>Total</th>
              <th>Dispense</th>
              <th>Payée</th>
              <th>Reste</th>
              <th>Actions</th>
            </tr>
          </thead>
          {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><Loading /></td></tr></tbody> :
            <tbody>
              {showFactures && showFactures.map(o => (
                <tr className='hover:bg-gray-200' key={o.id}>
                  <td>{o.dateFacture}</td>
                  <td>{o.description}</td>
                  <td>{o.inscription.eleve}</td>
                  <td>{o.inscription.classe.libelle}</td>
                  <td>{o.inscription.telParent}</td>
                  <td>{o.inscription.dateInscription}</td>
                  <td>{o.total}</td>
                  <td>{o.dispense}</td>
                  <td>{o.payee}</td>
                  <td>{o.total - o.dispense - o.payee}</td>
                  <td><DropDownButton actions={[{
                    'libelle': "Payer",
                    'onClick': () => {
                      setSelectedFacture(o);
                      setShowAddPaiement(true);
                    }
                  },
                  {
                    'libelle': "Historiques",
                    'onClick': () => {
                      setSelectedFacture(o);
                      setShowHistoriques(true);
                    }
                  },
                  {
                    'libelle': "Dispense",
                    'onClick': () => {
                      setSelectedFacture(o);
                      setShowDispense(true);
                    }
                  },
                  {
                    'libelle': "Supprimer",
                    'onClick': () => {
                      supprimerFacture(o);
                    }
                  },
                  ]} />
                  </td>
                </tr>
              ))

              }
            </tbody>

          }

        </table>
        {
          showHistoriques ? <Historiques onClose={closeHistorique} facture={selectedFacture} /> : <></>
        }
        {
          showAddPaiement ? <AddPaiement onClose={closeAddPaiement} facture={selectedFacture} /> : <></>
        }
        {
          showDispense ? <Dispense onClose={closeDispense} facture={selectedFacture} /> : <></>
        }
      </div>

    </>
  )
}

export default Factures